









































import { Component } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import Vue from "vue";
import { passwordApi } from "../services/password.api";

@Component({})
export default class PasswordResetRequest extends Vue {
  userNameOrEmail = "";
  emailSent = false;
  valid = false;
  loading = false;

  resetPassword() {
    (this.$refs.form as any).validate();
    if (this.valid) {
      this.loading = true;
      passwordApi.passwordResetRequest(this.userNameOrEmail).then(() => {
        this.emailSent = true;
      });
    }
  }

  closeTab() {
    window.close();
  }
}
